import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid, Stack, TextField } from '@mui/material';
import React, { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from '../../services';
import { FileUploader } from '../FileUploader';
import styles from '../StudyRequestForm/StudyRequestForm.module.css';
import { addAttachmentValidationSchema } from './addAttachment.validation.schema';

interface AddAttachmentsFormInterface {
	values: {
		notes: string;
		requestAttachments: any[];
	};
	onSubmit: (props: any) => void;
}

const AddAttachmentsForm: FC<AddAttachmentsFormInterface> = ({ values, onSubmit }) => {
	const { t } = useTranslation();
	const {
		control,
		formState: { errors },
		handleSubmit,
	} = useForm({
		defaultValues: values,
		resolver: yupResolver(addAttachmentValidationSchema),
	});

	return (
		<form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Controller
						name="requestAttachments"
						control={control}
						render={({ field }) => (
							<FileUploader
								required
								label={t('Request Attachments')}
								accept="image/*"
								error={!!errors.requestAttachments}
								helper={t(errors.requestAttachments?.message || '')}
								{...field}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Controller
						name="notes"
						control={control}
						render={({ field }) => (
							<TextField
								required
								error={!!errors.notes}
								helperText={
									errors.notes?.message && t(errors.notes.message)
								}
								className={styles.fullWidth}
								label={t('Reason')}
								multiline
								rows={4}
								{...field}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Stack direction="row" spacing={2}>
						<Button type="submit" variant="contained">
							{t('Send')}
						</Button>
					</Stack>
				</Grid>
			</Grid>
		</form>
	);
};

export default AddAttachmentsForm;
